"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalJsonFromJSON = AdditionalJsonFromJSON;
exports.AdditionalJsonFromJSONTyped = AdditionalJsonFromJSONTyped;
exports.AdditionalJsonToJSON = AdditionalJsonToJSON;
exports.AdditionalJsonToJSONTyped = AdditionalJsonToJSONTyped;
const runtime_1 = require("../runtime");
function AdditionalJsonFromJSON(json) {
    return AdditionalJsonFromJSONTyped(json, false);
}
function AdditionalJsonFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'celebFacebook': !(0, runtime_1.exists)(json, 'celebFacebook') ? undefined : json['celebFacebook'],
        'celebTwitter': !(0, runtime_1.exists)(json, 'celebTwitter') ? undefined : json['celebTwitter'],
        'celebGoogle': !(0, runtime_1.exists)(json, 'celebGoogle') ? undefined : json['celebGoogle'],
        'celebInstagram': !(0, runtime_1.exists)(json, 'celebInstagram') ? undefined : json['celebInstagram'],
        'celebTumblr': !(0, runtime_1.exists)(json, 'celebTumblr') ? undefined : json['celebTumblr'],
        'celebPhone': !(0, runtime_1.exists)(json, 'celebPhone') ? undefined : json['celebPhone'],
        'introductionVideo': !(0, runtime_1.exists)(json, 'introductionVideo') ? undefined : json['introductionVideo'],
    };
}
function AdditionalJsonToJSON(value) {
    return AdditionalJsonToJSONTyped(value, false);
}
function AdditionalJsonToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'celebFacebook': value.celebFacebook,
        'celebTwitter': value.celebTwitter,
        'celebGoogle': value.celebGoogle,
        'celebInstagram': value.celebInstagram,
        'celebTumblr': value.celebTumblr,
        'celebPhone': value.celebPhone,
        'introductionVideo': value.introductionVideo,
    };
}
